import type { StyleOption } from '../types/config'

interface StyleSelectorProps {
  styles: StyleOption[]
  selectedId: string
  onSelect: (id: string) => void
  label?: string
}

export function StyleSelector({ styles, selectedId, onSelect, label }: StyleSelectorProps) {
  return (
    <div className="space-y-3">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <div className="flex flex-wrap gap-4 justify-center">
        {styles.map((style) => (
          <button
            key={style.id}
            onClick={() => onSelect(style.id)}
            className={`
              relative flex flex-col items-center p-3 rounded-xl border-2 transition-all duration-200
              ${selectedId === style.id 
                ? 'border-exness-yellow bg-yellow-50 shadow-md' 
                : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }
            `}
            type="button"
          >
            <div className="w-20 h-20 mb-2 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
              {style.previewImage ? (
                <img 
                  src={style.previewImage} 
                  alt={style.name}
                  className="w-full h-full object-contain"
                />
              ) : (
                <div className="text-gray-400 text-xs">Preview</div>
              )}
            </div>
            <span 
              className={`
                text-sm font-medium
                ${selectedId === style.id ? 'text-exness-dark' : 'text-gray-600'}
              `}
            >
              {style.name}
            </span>
            {selectedId === style.id && (
              <div className="absolute -top-1 -right-1 w-5 h-5 bg-exness-yellow rounded-full flex items-center justify-center">
                <svg className="w-3 h-3 text-exness-dark" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
